export function navigateToTop(url) {
  window.top.location.assign(url);
}